
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b15e37f6&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./decorationCases.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./decorationCases.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b15e37f6!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./decorationCases.vue"),
  /* scopeId */
  "data-v-b15e37f6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/storeManagement/decorationCases.vue
// module id = 1590
// module chunks = 3